/* eslint-disable no-unused-vars */

import moment from 'moment-timezone'
import axios from '@/utils/axios_iface'

var core_versions_field = {
  data: {
    collection_id: 'core_versions',
    collection_sort_by_field_name: 'versions',
    collection_store_field_name: 'versions',
    collection_display_field_name: 'versions',
    dependent_filters: [],
    filter: [],
    brand_required: false,
    store_required: false,
    lookahead: false,
  },
}

var brand_versions_field = {
  data: {
    collection_id: 'versions',
    collection_sort_by_field_name: 'versions',
    collection_store_field_name: 'versions',
    collection_display_field_name: 'versions',
    dependent_filters: [],
    filter: [],
    brand_required: true,
    store_required: false,
    lookahead: false,
    no_model: true,
  },
}

var brands_field = {
  data: {
    collection_id: 'brands',
    collection_sort_by_field_name: 'name',
    collection_store_field_name: '_id',
    collection_display_field_name: 'name',
    dependent_filters: [],
    filter: [],
    brand_required: false,
    store_required: false,
    lookahead: false,
    query: { available_goorder: true },
  },
}

var goorder_language = {
  data: {
    collection_id: 'goorder_language',
    collection_sort_by_field_name: 'name',
    collection_store_field_name: 'enabled_languages',
    collection_display_field_name: 'name',
    filter: [],
    dependent_filters: [],
    brand_required: false,
    query: { orderBy: 'enabled_languages', ascending: 1 },
    store_required: false,
    lookahead: false,
    page_id: 'goorder_language_main_tbl',
  },
}

var currencies = {
  data: {
    collection_id: 'currencies',
    collection_sort_by_field_name: '_id',
    collection_store_field_name: '_id',
    collection_display_field_name: '_id',
    filter: [],
    dependent_filters: [],
    brand_required: false,
    query: { orderBy: 'short_name', ascending: 1 },
    store_required: false,
    lookahead: false,
    page_id: 'currencies_main_tbl',
  },
}

var settings = {
  data: {
    collection_id: 'settings',
    collection_sort_by_field_name: '_id',
    collection_store_field_name: '_id',
    collection_display_field_name: '_id',
    filter: [],
    brand_required: false,
    query: { orderBy: 'created_at', ascending: 1 },
    store_required: false,
    lookahead: false,
    page_id: 'settings_main_tbl',
  },
}

var new_style_delivery_areas_field = {
  data: {
    collection_id: 'new_style_delivery_areas',
    collection_sort_by_field_name: 'value',
    collection_store_field_name: 'value',
    collection_display_field_name: 'value',
    filter: [],
    query: { item_status: true },
    dependent_filters: [],
    brand_required: false,
    store_required: false,
    lookahead: true,
    keep_on_page_change: true,
  },
}
var new_style_brand_delivery_areas = {
  data: {
    collection_id: 'new_style_brand_delivery_areas',
    collection_sort_by_field_name: 'value',
    collection_store_field_name: 'value',
    collection_display_field_name: 'value',
    filter: [],
    query: { item_status: true },
    dependent_filters: [],
    brand_required: true,
    store_required: false,
    lookahead: true,
    keep_on_page_change: true,
  },
}

var store_delivery_areas_field = {
  data: {
    collection_id: 'new_style_root_delivery_areas',
    collection_sort_by_field_name: 'delivery_area',
    collection_store_field_name: '_id',
    collection_display_field_name: 'delivery_area',
    dependent_filters: [],
    filter: [],
    brand_required: false,
    store_required: false,
    lookahead: true,
    keep_on_page_change: true,
    query: { item_status: true },
    after_load_dispatch: 'build_store_delivery_areas_map',
  },
}

var root_stores_field = {
  data: {
    collection_id: 'root_stores',
    collection_sort_by_field_name: 'name',
    collection_store_field_name: '_id',
    collection_display_field_name: 'name',
    dependent_filters: [],
    filter: [],
    brand_required: false,
    store_required: false,
    lookahead: false,
    after_load_dispatch: 'build_store_delivery_areas_map',
    query: { available_goorder: true },
  },
}

var root_order_discount_field = {
  data: {
    collection_id: 'root_order_discounts',
    collection_sort_by_field_name: 'name',
    collection_store_field_name: '_id',
    collection_display_field_name: 'name',
    dependent_filters: [],
    filter: [],
    brand_required: false,
    store_required: false,
    lookahead: false,
    query: { online: true, available_goorder: true, manual: false },
  },
}

var brand_stores_field = {
  data: {
    collection_id: 'stores',
    collection_sort_by_field_name: 'name',
    collection_store_field_name: '_id',
    collection_display_field_name: 'name',
    dependent_filters: [],
    filter: [],
    brand_required: true,
    store_required: false,
    lookahead: false,
  },
}

var brand_offers_field = {
  data: {
    collection_id: 'brand_offers',
    collection_sort_by_field_name: 'title',
    collection_store_field_name: '_id',
    collection_display_field_name: 'title',
    dependent_filters: [],
    filter: [],
    brand_required: true,
    store_required: false,
    lookahead: false,
    query: { enabled: 'true' },
  },
}

var brand_website_banners = {
  data: {
    collection_id: 'brand_website_banners',
    collection_sort_by_field_name: 'title',
    collection_store_field_name: '_id',
    collection_display_field_name: 'title',
    dependent_filters: [],
    filter: [],
    brand_required: true,
    store_required: false,
    lookahead: false,
    query: { enabled: 'true', orderBy: 'priority', ascending: 1 },
    page_id: 'brand_website_banners_main_tbl',
  },
}

var web_translations_field = {
  data: {
    collection_id: 'translations',
    collection_sort_by_field_name: 'en-US',
    collection_store_field_name: '_id',
    collection_display_field_name: 'en-US',
    dependent_filters: [],
    filter: [],
    brand_required: false,
    store_required: false,
    lookahead: false,
    page_id: 'web_translations_cache',
  },
}

var brand_web_translations = {
  data: {
    collection_id: 'brand_web_translations',
    collection_sort_by_field_name: 'en-US',
    collection_store_field_name: '_id',
    collection_display_field_name: 'en-US',
    // query: {orderBy: 'enabled_languages', 'ascending': 0},
    dependent_filters: [],
    filter: [],
    brand_required: true,
    store_required: false,
    lookahead: false,
    page_id: 'brand_web_translations_cache',
  },
}

var languages_field = {
  data: {
    collection_id: 'languages',
    collection_sort_by_field_name: 'code',
    collection_store_field_name: 'code',
    collection_display_field_name: 'code',
    dependent_filters: [],
    filter: [],
    brand_required: false,
    store_required: false,
    lookahead: false,
  },
}

var timezones_field = {
  data: {
    collection_id: 'timezones',
    collection_sort_by_field_name: 'name',
    collection_store_field_name: '_id',
    collection_display_field_name: 'name',
    dependent_filters: [],
    filter: [],
    brand_required: false,
    store_required: false,
    lookahead: false,
  },
}

var countries_field = {
  data: {
    collection_id: 'countries',
    collection_sort_by_field_name: 'name',
    collection_store_field_name: 'country_code',
    collection_display_field_name: 'name',
    dependent_filters: [],
    filter: [],
    brand_required: false,
    store_required: false,
    lookahead: false,
  },
}

var store_menu_items_quick_view = {
  data: {
    collection_id: 'brand_menu_items',
    collection_sort_by_field_name: 'priority',
    collection_store_field_name: '_id',
    collection_display_field_name: 'name',
    dependent_filters: [],
    filter: [],
    brand_required: true,
    store_required: false,
    lookahead: false,
    query: { item_type: 'regular', shown_web: true }, //remove this condition for fetch combo item & other item type
    page_id: 'brand_menu_items_main_tbl',
  },
}
var store_item_categories = {
  data: {
    collection_id: 'brand_item_categories',
    collection_sort_by_field_name: 'priority',
    collection_store_field_name: '_id',
    collection_display_field_name: 'name',
    dependent_filters: [],
    filter: [],
    brand_required: true,
    store_required: false,
    lookahead: false,
    query: { shown_web: true },
  },
}

var store_item_subcategories = {
  data: {
    collection_id: 'brand_item_sub_categories',
    collection_sort_by_field_name: 'priority',
    collection_store_field_name: '_id',
    collection_display_field_name: 'name',
    dependent_filters: [],
    filter: [],
    brand_required: true,
    store_required: false,
    lookahead: false,
    query: { item_status: true, shown_web: true },
  },
}

var goorder_type_field = {
  data: {
    collection_id: 'goorder_types',
    collection_sort_by_field_name: 'name',
    collection_store_field_name: 'name',
    collection_display_field_name: 'name',
    dependent_filters: [],
    filter: [],
    brand_required: false,
    store_required: false,
    lookahead: false,
    page_id: 'goorder_types_main_tbl',
  },
}

var goorder_offers_field = {
  data: {
    collection_id: 'goorder_offers',
    collection_sort_by_field_name: 'title',
    collection_store_field_name: '_id',
    collection_display_field_name: 'title',
    dependent_filters: [],
    filter: [],
    brand_required: false,
    store_required: false,
    lookahead: false,
    page_id: 'goorder_offers_main_tbl',
    query: { enabled: 'true' },
  },
}

var goorder_kitchen_types_field = {
  data: {
    collection_id: 'kitchen_types',
    collection_sort_by_field_name: 'name',
    collection_store_field_name: '_id',
    collection_display_field_name: 'name',
    dependent_filters: [],
    filter: [],
    brand_required: false,
    store_required: false,
    lookahead: false,
    page_id: 'kitchen_types_main_tbl',
  },
}

var item_modifier_groups = {
  data: {
    collection_id: 'brand_item_modifiers_group',
    collection_sort_by_field_name: 'priority',
    collection_store_field_name: '_id',
    collection_display_field_name: 'name',
    dependent_filters: [],
    filter: [],
    brand_required: true,
    store_required: false,
    lookahead: false,
    page_id: 'brand_item_modifiers_group_main_tbl',
    query: { item_status: true, shown_web: true },
  },
}
var item_modifier_subgroups = {
  data: {
    collection_id: 'brand_item_modifiers_sub_group',
    collection_sort_by_field_name: 'priority',
    collection_store_field_name: '_id',
    collection_display_field_name: 'name',
    dependent_filters: [],
    filter: [],
    brand_required: true,
    store_required: false,
    lookahead: false,
    page_id: 'brand_item_modifiers_sub_group_main_tbl',
    query: { item_status: true, shown_web: true },
  },
}
var item_modifiers = {
  data: {
    collection_id: 'brand_item_modifiers',
    collection_sort_by_field_name: 'name',
    collection_store_field_name: '_id',
    collection_display_field_name: 'name',
    dependent_filters: [],
    filter: [],
    brand_required: true,
    store_required: false,
    lookahead: false,
    query: { shown_web: true },
  },
}
var item_discounts = {
  data: {
    collection_id: 'brand_item_discounts',
    collection_sort_by_field_name: 'name',
    collection_store_field_name: '_id',
    collection_display_field_name: 'name',
    dependent_filters: [],
    filter: [],
    brand_required: true,
    store_required: false,
    lookahead: false,
    query: { online: true },
  },
}
var order_discounts = {
  data: {
    collection_id: 'brand_order_discounts',
    collection_sort_by_field_name: 'name',
    collection_store_field_name: '_id',
    collection_display_field_name: 'name',
    dependent_filters: [],
    filter: [],
    brand_required: true,
    store_required: false,
    lookahead: false,
    query: { online: true, manual: false },
  },
}

var additional_surcharges = {
  data: {
    collection_id: 'brand_additional_surcharges',
    collection_sort_by_field_name: 'name',
    collection_store_field_name: '_id',
    collection_display_field_name: 'name',
    dependent_filters: [],
    filter: [],
    brand_required: true,
    store_required: false,
    lookahead: false,
    lookups_needed: 1,
    query: { online: true },
    after_load_dispatch: 'set_additonal_surcharge_lookups',
  },
}
var payment_types = {
  data: {
    collection_id: 'brand_payment_types',
    collection_sort_by_field_name: 'name',
    collection_store_field_name: '_id',
    collection_display_field_name: 'name',
    dependent_filters: [],
    filter: [],
    brand_required: true,
    store_required: false,
    lookahead: false,
    query: { item_status: 'true' },
  },
}

var goorder_price_range = {
  data: {
    collection_id: 'brand_price_range',
    collection_sort_by_field_name: 'priority',
    collection_store_field_name: '_id',
    collection_display_field_name: 'name',
    dependent_filters: [],
    filter: [],
    brand_required: false,
    store_required: false,
    lookahead: false,
  },
}

var customer = {
  data: {
    collection_id: 'goorder_customers',
    collection_sort_by_field_name: 'name',
    collection_store_field_name: '_id',
    collection_display_field_name: 'name',
    dependent_filters: [],
    filter: [],
    brand_required: false,
    store_required: false,
    lookahead: false,
    keep_on_page_change: true,
    entities: { id: false },
  },
}

var customer_orders = {
  data: {
    collection_id: 'root_orders',
    collection_sort_by_field_name: 'real_created_datetime',
    collection_store_field_name: '_id',
    collection_display_field_name: 'name',
    dependent_filters: [],
    filter: [],
    brand_required: false,
    store_required: false,
    lookahead: true,
    keep_on_page_change: true,
    query: {},
    page_id: 'go_customer_orders_details',
  },
}

var brands_static_pages = {
  data: {
    collection_id: 'brand_cms_pages',
    collection_sort_by_field_name: 'page_title',
    collection_store_field_name: '_id',
    collection_display_field_name: 'name',
    dependent_filters: [],
    filter: [],
    brand_required: true,
    store_required: false,
    lookahead: false,
    query: { item_status: 'true' },
    page_id: 'brand_cms_pages_main_tbl',
  },
}

var goorder_settings = {
  data: {
    collection_id: 'goorder_setting',
    collection_sort_by_field_name: 'email',
    collection_store_field_name: '_id',
    collection_display_field_name: 'name',
    dependent_filters: [],
    filter: [],
    brand_required: false,
    store_required: false,
    lookahead: false,
    page_id: 'goorder_setting_main_tbl',
  },
}

var business_types = {
  data: {
    collection_id: 'brand_business_type',
    collection_sort_by_field_name: 'priority',
    collection_store_field_name: '_id',
    collection_display_field_name: 'name',
    dependent_filters: [],
    filter: [],
    brand_required: false,
    store_required: false,
    lookahead: false,
    page_id: 'brand_business_type_main_tbl',
    query: { item_status: 'true' },
  },
}

export default {
  state: {
    core_versions_load_time: 0,
    core_version_load_in_progress: false,
    core_versions_after_load_resolvers: [],
    pwa_config: {},
  },
  mutations: {
    SET_CORE_VERSION_LOAD_TIME: (state, version_load_time) =>
      (state.core_versions_load_time = version_load_time),
    SET_CORE_VERSION_LOAD_IN_PROGRESS: (state, progress) =>
      (state.core_version_load_in_progress = progress),
    ADD_AFTER_CORE_VERSION_RESOLVER: (state, resolver) =>
      state.core_versions_after_load_resolvers.push(resolver),
    CLEAN_AFTER_CORE_VERSION_RESOLVERS: (state, resolver) =>
      (state.core_versions_after_load_resolvers = []),
    SET_PWA_CONFIG: (state, data) => (state.pwa_config = data),
  },
  actions: {
    getDataCoreVersionsCollection: (
      { dispatch, commit, state, getters },
      field
    ) => {
      if (state.core_versions_load_time < moment().add(-5, 'minutes')) {
        return new Promise((resolve, reject) => {
          let versionsAction = 'load_core_versions'
          if (getters.domainBasedBrand) {
            versionsAction = 'load_brand_versions'
          }

          dispatch(versionsAction).then(() => {
            dispatch('getData', field).then(() => {
              resolve()
            })
          })
        })
      } else {
        return dispatch('getData', field)
      }
    },
    load_core_versions: ({ dispatch, commit, state }) => {
      if (state.core_version_load_in_progress) {
        var pr = new Promise((resolve, reject) => {
          commit('ADD_AFTER_CORE_VERSION_RESOLVER', resolve)
        })
        return pr
      } else {
        var resolve_function
        var pr = new Promise((resolve) => {
          resolve_function = resolve
        })
        dispatch('getData', core_versions_field).then(() => {
          commit('SET_CORE_VERSION_LOAD_TIME', moment())
          commit('SET_CORE_VERSION_LOAD_IN_PROGRESS', false)
          resolve_function()
          for (var resolver of state.core_versions_after_load_resolvers) {
            resolver()
          }
          commit('CLEAN_AFTER_CORE_VERSION_RESOLVERS')
        })
        commit('SET_CORE_VERSION_LOAD_IN_PROGRESS', true)
        return pr
      }
    },
    load_brand_versions: ({ dispatch, state, getters, commit }) => {
      return new Promise((resolve) => {
        dispatch('getData', brand_versions_field).then(() => {
          resolve()
        })
      })
    },
    load_brands: ({ dispatch, state }) =>
      dispatch('getDataCoreVersionsCollection', brands_field),
    load_brand_stores: ({ dispatch, state }) =>
      dispatch('getDataCoreVersionsCollection', brand_stores_field),
    load_brand_website_banners: ({ dispatch, state }) =>
      dispatch('getDataCoreVersionsCollection', brand_website_banners),
    load_web_translations: ({ dispatch, state }) =>
      dispatch('getDataCoreVersionsCollection', web_translations_field),
    load_brand_web_translations: ({ dispatch, state }) =>
      dispatch('getDataCoreVersionsCollection', brand_web_translations),
    load_languages: ({ dispatch, state }) =>
      dispatch('getDataCoreVersionsCollection', languages_field),
    load_timezones: ({ dispatch, state }) =>
      dispatch('getDataCoreVersionsCollection', timezones_field),
    load_countries: ({ dispatch, state }) =>
      dispatch('getDataCoreVersionsCollection', countries_field),
    load_business_types: ({ dispatch, state }) =>
      dispatch('getDataCoreVersionsCollection', business_types),
    // load_brand_menu_items: ({ dispatch, state }) =>
    //   dispatch('getData', store_menu_items),
    load_quick_view_menu_items: ({ dispatch, state }, params) => {
      store_menu_items_quick_view.data.brand_id = params.brand_id
      store_menu_items_quick_view.data.store_id = params.store_id

      let store_item_categories_quick_view = { ...store_item_categories }
      store_item_categories_quick_view.data.brand_id = params.brand_id
      store_item_categories_quick_view.data.store_id = params.store_id
      // store_menu_items.data.entities[params.brand_id] = params.store_id
      return dispatch(
        'getDataCoreVersionsCollection',
        store_item_categories_quick_view
      ).then(() => {
        return dispatch(
          'getDataCoreVersionsCollection',
          store_menu_items_quick_view
        )
      })
    },
    load_root_stores: ({ dispatch, state }) =>
      dispatch('getDataCoreVersionsCollection', root_stores_field),
    load_goorder_types: ({ dispatch, state }) =>
      dispatch('getDataCoreVersionsCollection', goorder_type_field),
    load_offers: ({ dispatch, state, getters }) => {
      if (getters.domainBasedBrand) {
        dispatch('getDataCoreVersionsCollection', brand_offers_field)
      } else {
        dispatch('getDataCoreVersionsCollection', goorder_offers_field)
      }
    },
    load_goorder_price_ranges: ({ dispatch, state }) =>
      dispatch('getDataCoreVersionsCollection', goorder_price_range),
    load_goorder_kitchen_types: ({ dispatch, state }) =>
      dispatch('getDataCoreVersionsCollection', goorder_kitchen_types_field),
    load_brand_item_categories: ({ dispatch, state }) =>
      dispatch('getDataCoreVersionsCollection', store_item_categories),
    load_brand_item_subcategories: ({ dispatch, state }) =>
      dispatch('getDataCoreVersionsCollection', store_item_subcategories),
    load_brand_item_modifier_groups: ({ dispatch, state }) =>
      dispatch('getDataCoreVersionsCollection', item_modifier_groups),
    load_brand_item_modifier_subgroups: ({ dispatch, state }) =>
      dispatch('getDataCoreVersionsCollection', item_modifier_subgroups),
    load_brand_item_modifiers: ({ dispatch, state }) =>
      dispatch('getDataCoreVersionsCollection', item_modifiers),
    load_brand_item_discounts: ({ dispatch, state }) =>
      dispatch('getDataCoreVersionsCollection', item_discounts),
    load_root_order_discounts: ({ dispatch, state }) =>
      dispatch('getDataCoreVersionsCollection', root_order_discount_field),

    load_brand_order_discounts: ({ dispatch, state, getters }) => {
      if (!getters.domainBasedBrand) {
        order_discounts.data.filter.push({
          type: 'eq',
          attribute: 'available_goorder',
          value: true,
        })
      }
      dispatch('getDataCoreVersionsCollection', order_discounts)
    },
    load_brand_additional_surcharges: ({ dispatch, state }) =>
      dispatch('getDataCoreVersionsCollection', additional_surcharges),
    load_brand_payment_types: ({ dispatch, state }) =>
      dispatch('getDataCoreVersionsCollection', payment_types),
    load_customer: ({ dispatch, state, getters }, forceReload = false) => {
      if (getters.domainBasedBrand) {
        customer.data.brand_required = true
        customer.data.collection_id = 'brand_customers'
      }
      if (!getters.web_user) return

      const webUserId =
        getters.web_user.id || localStorage.getItem('webuser_id')
      customer.data.entities['id'] = webUserId
      window.OneSignal.push(function () {
        window.OneSignal.setExternalUserId(webUserId)
        dispatch(
          'updateExternalHandler',
          'js-call:auth-status-change:' + webUserId
        )
      })

      let action = 'getData'
      if (forceReload) {
        action = 'getDataWithForceReload'
      }
      return dispatch(action, customer)
    },
    load_all_store_delivery_areas_by_value: ({ dispatch }) =>
      dispatch('getDataCoreVersionsCollection', store_delivery_areas_field),
    load_new_style_delivery_areas: ({ dispatch }) =>
      dispatch('getDataCoreVersionsCollection', new_style_delivery_areas_field),
    load_new_style_brand_delivery_areas: ({ dispatch }) =>
      dispatch('getDataCoreVersionsCollection', new_style_brand_delivery_areas),
    load_currencies: ({ dispatch }) =>
      dispatch('getDataCoreVersionsCollection', currencies),
    load_settings: ({ dispatch }) =>
      dispatch('getDataCoreVersionsCollection', settings),
    load_orders: ({ dispatch, getters }, forceReload) => {
      if (getters.web_user) {
        if (getters.domainBasedBrand) {
          customer_orders.data.collection_id = 'orders'
          customer_orders.data.page_id = 'customer_orders_details'
          customer_orders.data.query.customer = getters.web_user
            ? getters.web_user.id
            : ''
          customer_orders.data.brand_required = true
          delete customer_orders.data.query.go_order_customer
        } else if (getters.web_user) {
          customer_orders.data.query.go_order_customer = getters.web_user.id
        }
        if (forceReload) {
          return dispatch('getDataWithForceReload', customer_orders)
        } else {
          return dispatch('getDataCoreVersionsCollection', customer_orders)
        }
      } else {
        return Promise.resolve()
      }
    },
    load_static_pages: ({ dispatch, getters }) => {
      if (!getters.domainBasedBrand) {
        brands_static_pages.data.collection_id = 'goorder_pages'
        brands_static_pages.data.page_id = 'goorder_pages_main_tbl'
        brands_static_pages.data.brand_required = false
        dispatch('getDataCoreVersionsCollection', brands_static_pages)
      } else {
        dispatch('getDataCoreVersionsCollection', brands_static_pages)
      }
    },
    attach_service_worker: () => {
      // eslint-disable-next-line no-undef
      if (
        'serviceWorker' in navigator &&
        process.env.NODE_ENV !== 'development'
      ) {
        let refreshing = false

        navigator.serviceWorker.addEventListener('controllerchange', () => {
          console.log('controller changed, refreshing')
          if (!refreshing) {
            const time = +new Date()

            let lastUpdatedTime =
              parseInt(localStorage.getItem('sw_refreshed')) || 0

            if (lastUpdatedTime + 1000 * 60 * 60 * 12 <= time) {
              localStorage.setItem('sw_refreshed', time)
              window.location.reload()
              refreshing = true
            }
          }
        })
        navigator.serviceWorker.register('/OneSignalSDKWorker.js')
      }
    },
    generate_manifest_url: ({ dispatch, getters, commit }) => {
      //const newAxios = axios.create()
      //delete newAxios.defaults.headers.Authorization
      //newAxios
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + '/get_web_manifest')
        .then((response) => {
          commit('SET_PWA_CONFIG', response.data)
          const stringManifest = JSON.stringify(response.data)
          const blob = new Blob([stringManifest], { type: 'application/json' })
          const manifestURL = URL.createObjectURL(blob)
          document.querySelector('#manifest').setAttribute('href', manifestURL)

          var link = document.createElement('Link')
          link.rel = 'manifest'
          link.setAttribute(
            'href',
            'data:application/json;charset=8' + stringManifest
          )
        })

      // document
      //   .querySelector('#manifest')
      //   .setAttribute(
      //     'href',
      //     process.env.VUE_APP_API_ENDPOINT + '/get_web_manifest'
      //   )
    },
    load_goorder_settings: ({ dispatch }) =>
      dispatch('getDataCoreVersionsCollection', goorder_settings),
    load_goorder_language: ({ dispatch }) =>
      dispatch('getDataCoreVersionsCollection', goorder_language),
    // load_dinein_areas: ({ dispatch }) =>
    //   dispatch('getData', dinein_areas),
  },
  getters: {
    pwa_config: (state) => state.pwa_config,
    all_brands: (state, getters) =>
      getters.get_collection_data(brands_field, undefined),
    all_brands_being_loaded: (state, getters) =>
      getters.collection_being_loaded(brands_field),
    find_brand_by_main_id: (state, getters) => (item_id) => {
      if (getters.domainBasedBrand) {
        return getters.currentBrand
      }
      return getters.find_in_collection_data(brands_field, item_id)
    },

    all_core_versions: (state, getters) => {
      let field = core_versions_field
      if (getters.domainBasedBrand) {
        field = brand_versions_field
      }
      const data = getters.get_collection_data(field, undefined)
      return Object.assign(
        {},
        data.store_versions,
        data.brand_versions,
        data.global_versions
      )
    },
    all_core_versions_deps: (state, getters) => {
      let field = core_versions_field
      if (getters.domainBasedBrand) {
        field = brand_versions_field
      }
      const data = getters.get_collection_data(field, undefined)
      return data.dep_tree
    },
    all_core_versions_being_loaded: (state, getters) =>
      getters.collection_being_loaded(core_versions_field),
    all_brand_versions: (state, getters) =>
      getters.get_collection_data(brand_versions_field, undefined),
    all_brand_versions_being_loaded: (state, getters) =>
      getters.collection_being_loaded(brand_versions_field),

    all_brand_stores: (state, getters) =>
      getters.get_collection_data(brand_stores_field, undefined),
    all_brand_website_banners: (state, getters) =>
      getters.currentBrand
        ? getters.get_collection_data(brand_website_banners, undefined)
        : [],
    all_brand_stores_loaded: (state, getters) =>
      getters.currentBrand
        ? getters.collection_being_loaded(brand_stores_field)
        : false,
    find_brand_store_by_main_id: (state, getters) => (item_id) =>
      getters.find_in_collection_data(brand_stores_field, item_id),

    all_web_translations: (state, getters) =>
      getters.get_collection_data(web_translations_field, undefined),
    all_brand_web_translations: (state, getters) =>
      getters.get_collection_data(brand_web_translations, undefined),
    all_web_translations_being_loaded: (state, getters) =>
      getters.collection_being_loaded(web_translations_field),
    find_web_translation_by_main_id: (state, getters) => (item_id) =>
      getters.find_in_collection_data(web_translations_field, item_id),
    find_brand_web_translations_by_main_id: (state, getters) => (item_id) =>
      getters.find_in_collection_data(brand_web_translations, item_id),

    all_languages: (state, getters) =>
      getters.get_collection_data(languages_field, undefined),
    all_languages_loaded: (state, getters) =>
      getters.collection_being_loaded(languages_field),
    find_language_by_main_id: (state, getters) => (item_id) =>
      getters.find_in_collection_data(languages_field, item_id),

    all_timezones: (state, getters) =>
      getters.get_collection_data(timezones_field, undefined),
    all_timezones_being_loaded: (state, getters) =>
      getters.collection_being_loaded(timezones_field),
    find_timezone_by_main_id: (state, getters) => (item_id) =>
      getters.find_in_collection_data(timezones_field, item_id),

    all_countries: (state, getters) =>
      getters.get_collection_data(countries_field, undefined),
    all_countries_being_loaded: (state, getters) =>
      getters.collection_being_loaded(countries_field),
    find_country_by_main_id: (state, getters) => (item_id) =>
      getters.find_in_collection_data(countries_field, item_id),

    all_business_types: (state, getters) =>
      getters.get_collection_data(business_types, undefined),
    all_business_types_being_loaded: (state, getters) =>
      getters.collection_being_loaded(business_types),
    find_business_type_by_main_id: (state, getters) => (item_id) =>
      getters.find_in_collection_data(business_types, item_id),

    // all_store_menu_items: (state, getters) =>
    //   getters.currentBrand
    //     ? getters.get_collection_data(store_menu_items, undefined)
    //     : [],
    // all_store_menu_items_being_loaded: (state, getters) =>
    //   getters.currentBrand
    //     ? getters.collection_being_loaded(store_menu_items)
    //     : false,
    // find_store_menu_item_by_main_id: (state, getters) => item_id =>
    //   getters.find_in_collection_data(store_menu_items, item_id),

    quick_view_store_menu_items: (state, getters) => (params) =>
      params.brand_id
        ? getters.get_collection_data(store_menu_items_quick_view, undefined)
        : [],
    quick_view_store_categories: (state, getters) => (params) =>
      params.brand_id
        ? getters.get_collection_data(store_item_categories, undefined)
        : [],

    all_raw_store_categories: (state, getters) =>
      getters.currentBrand
        ? getters.get_collection_data(store_item_categories, undefined)
        : [],
    all_store_categories_being_loaded: (state, getters) =>
      getters.currentBrand
        ? getters.collection_being_loaded(store_item_categories)
        : false,
    find_store_item_category_by_main_id: (state, getters) => (item_id) =>
      getters.find_in_collection_data(store_item_categories, item_id),

    all_raw_store_subcategories: (state, getters) =>
      getters.currentBrand
        ? getters.get_collection_data(store_item_subcategories, undefined)
        : [],
    all_store_subcategories_being_loaded: (state, getters) =>
      getters.currentBrand
        ? getters.collection_being_loaded(store_item_subcategories)
        : false,
    find_store_item_subcategory_by_main_id: (state, getters) => (item_id) =>
      getters.find_in_collection_data(store_item_subcategories, item_id),

    all_stores: (state, getters) => {
      let stores = getters.get_collection_data(root_stores_field, undefined)
      if (getters.domainBasedBrand) {
        stores = getters.get_collection_data(brand_stores_field, undefined)
      }
      return stores.filter((store) => store.website)
    },

    all_stores_being_loaded: (state, getters) =>
      getters.collection_being_loaded(root_stores_field),
    find_store_by_main_id: (state, getters) => (item_id) => {
      if (getters.domainBasedBrand) {
        return getters.find_brand_store_by_main_id(item_id)
      }
      return getters.find_in_collection_data(root_stores_field, item_id)
    },
    find_stores_by_brand_id: (state, getters) => (brand_id) =>
      getters.find_in_collection_data_by_brand_id(root_stores_field, brand_id),

    all_root_discounts: (state, getters) =>
      getters.get_collection_data(root_order_discount_field, undefined),
    all_root_discounts_being_loaded: (state, getters) =>
      getters.collection_being_loaded(root_order_discount_field),
    find_root_discount_by_main_id: (state, getters) => (item_id) =>
      getters.find_in_collection_data(root_order_discount_field, item_id),
    find_root_discount_by_brand_id: (state, getters) => (brand_id) =>
      getters.find_in_collection_data_by_brand_id(
        root_order_discount_field,
        brand_id
      ),

    all_goorder_types: (state, getters) =>
      getters.get_collection_data(goorder_type_field, undefined),
    all_goorder_types_being_loaded: (state, getters) =>
      getters.collection_being_loaded(goorder_type_field),
    find_goorder_type_by_main_id: (state, getters) => (item_id) =>
      getters.find_in_collection_data(goorder_type_field, item_id),

    all_goorder_price_ranges: (state, getters) =>
      getters.get_collection_data(goorder_price_range, undefined),
    all_goorder_price_ranges_being_loaded: (state, getters) =>
      getters.collection_being_loaded(goorder_price_range),
    find_goorder_price_range_by_main_id: (state, getters) => (item_id) =>
      getters.find_in_collection_data(goorder_price_range, item_id),

    all_goorder_offers: (state, getters) =>
      getters.get_collection_data(goorder_offers_field, undefined),
    all_goorder_offers_being_loaded: (state, getters) =>
      getters.collection_being_loaded(goorder_offers_field),

    all_brand_offers: (state, getters) =>
      getters.get_collection_data(brand_offers_field, undefined),
    all_brand_offers_being_loaded: (state, getters) =>
      getters.collection_being_loaded(brand_offers_field),

    all_goorder_kitchen_types: (state, getters) =>
      getters.get_collection_data(goorder_kitchen_types_field, undefined),
    all_goorder_kitchen_types_being_loaded: (state, getters) =>
      getters.collection_being_loaded(goorder_kitchen_types_field),
    find_goorder_kitchen_type_by_main_id: (state, getters) => (item_id) =>
      getters.find_in_collection_data(goorder_kitchen_types_field, item_id),

    all_item_modifier_groups: (state, getters) =>
      getters.get_collection_data(item_modifier_groups, undefined),
    all_item_modifier_groups_being_loaded: (state, getters) =>
      getters.collection_being_loaded(item_modifier_groups),
    find_item_modifier_group_by_main_id: (state, getters) => (item_id) =>
      getters.find_in_collection_data(item_modifier_groups, item_id),

    all_item_modifier_subgroups: (state, getters) =>
      getters.get_collection_data(item_modifier_subgroups, undefined),
    all_item_modifier_subgroups_being_loaded: (state, getters) =>
      getters.collection_being_loaded(item_modifier_subgroups),
    find_item_modifier_subgroup_by_main_id: (state, getters) => (item_id) =>
      getters.find_in_collection_data(item_modifier_subgroups, item_id),

    all_raw_item_modifiers: (state, getters) =>
      getters.get_collection_data(item_modifiers, undefined),
    all_item_modifiers_being_loaded: (state, getters) =>
      getters.collection_being_loaded(item_modifiers),
    find_item_modifier_by_main_id: (state, getters) => (item_id) =>
      getters.find_in_collection_data(item_modifiers, item_id),

    all_raw_item_discounts: (state, getters) =>
      getters.get_collection_data(item_discounts, undefined),
    all_item_discounts_being_loaded: (state, getters) =>
      getters.collection_being_loaded(item_discounts),
    find_item_discount_by_main_id: (state, getters) => (item_id) =>
      getters.find_in_collection_data(item_discounts, item_id),

    all_raw_order_discounts: (state, getters) =>
      getters.get_collection_data(order_discounts, undefined),
    all_order_discounts_being_loaded: (state, getters) =>
      getters.collection_being_loaded(order_discounts),
    find_order_discount_by_main_id: (state, getters) => (item_id) =>
      getters.find_in_collection_data(order_discounts, item_id),
    all_raw_additional_surcharges: (state, getters) =>
      getters.get_collection_data(additional_surcharges, undefined),
    all_additional_surcharges_being_loaded: (state, getters) =>
      getters.collection_being_loaded(additional_surcharges),
    find_additional_surcharge_by_main_id: (state, getters) => (item_id) =>
      getters.find_in_collection_data(additional_surcharges, item_id),

    all_delivery_areas: (state, getters) => {
      // getters.get_collection_data(new_style_delivery_areas_field),
      if (getters.domainBasedBrand) {
        return getters.brand_all_delivery_areas
      } else {
        return getters.all_store_delivery_areas
      }
    },

    all_delivery_areas_being_loaded: (state, getters) => (country) =>
      getters.collection_being_loaded(new_style_delivery_areas_field),
    find_delivery_areas_by_value: (state, getters) => (value) =>
      getters.find_in_collection_data(new_style_delivery_areas_field, value),

    brand_all_delivery_areas: (state, getters) =>
      getters.get_collection_data(new_style_brand_delivery_areas),
    brand_all_delivery_areas_being_loaded: (state, getters) =>
      getters.collection_being_loaded(new_style_brand_delivery_areas),
    brand_find_delivery_areas_by_value: (state, getters) => (value) =>
      getters.find_in_collection_data(new_style_brand_delivery_areas, value),
    all_store_delivery_areas: (state, getters) =>
      getters.get_collection_data(store_delivery_areas_field, undefined),
    all_store_delivery_areas_being_loaded: (state, getters) =>
      getters.collection_being_loaded(store_delivery_areas_field),

    all_raw_payment_types: (state, getters) =>
      getters.get_collection_data(payment_types, undefined),
    all_payment_types_being_loaded: (state, getters) =>
      getters.collection_being_loaded(payment_types),
    find_payment_type_by_main_id: (state, getters) => (item_id) =>
      getters.find_in_collection_data(payment_types, item_id),
    customer_being_loaded: (state, getters) =>
      getters.collection_being_loaded(customer, undefined),
    customer: (state, getters) =>
      getters.get_collection_data(customer, undefined),
    all_customer_orders: (state, getters) =>
      getters.get_collection_data(customer_orders, undefined),
    all_static_pages: (state, getters) =>
      getters.get_collection_data(brands_static_pages, undefined),
    // load_users: (state, getters) => getters.get_collection_data(users, undefined),
    all_goorder_settings: (state, getters) =>
      getters.get_collection_data(goorder_settings, undefined),
    all_goorder_language: (state, getters) =>
      getters.get_collection_data(goorder_language, 'enabled_languages'),
    // get_dinein_areas: (state, getters) =>
    //   getters.get_collection_data(dinein_areas, '_id'),
    // track_order: (state, getters)  => getters.get_collection_data(order_tracking, undefined),
    // all_store_referral: (state, getters)  => getters.get_collection_data(referrals, undefined),
    get_settings: (state, getters) =>
      getters.find_in_collection_data(settings, undefined),
    get_currencies: (state, getters) => (current_country_code) => {
      let currency = getters.get_collection_data(currencies, undefined)
      if (current_country_code) {
        return currency.find((currency) => {
          if (currency.enabled_countries.includes(current_country_code))
            return currency
        })
      } else {
        return undefined
      }
    },
    all_static_pages_by_slug_search: (state, getters) => (slug) => {
      return getters.all_static_pages.find(
        (staticPage) => staticPage.slug === slug
      )
    },
    brand_all_delivery_areas_split: (state, getters) => {
      let countries = {}
      let cities = {}
      let das = {}
      if (
        getters.brand_all_delivery_areas &&
        getters.brand_all_delivery_areas.length
      ) {
        for (const i in getters.brand_all_delivery_areas) {
          let [da, city, country] =
            getters.brand_all_delivery_areas[i].delivery_area.split('|')
          das[da] = { da: da, city: city }
          cities[city] = { city: city, country: country }
          countries[country] = country
        }
      }
      return { countries: countries, cities: cities, das: das }
    },
  },
}
